// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { TICKET } from 'conversations-message-history/crm-object-lifecycle-update/constants/objectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getObjectType } from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isTicketCreatedType } from 'conversations-message-history/crm-object-lifecycle-update/operators/isTicketCreatedType';
import PropTypes from 'prop-types';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../c... Remove this comment to see the full error message
import CrmTicketCreatedTile from '../crm-ticket-lifecycle-update/CrmTicketCreatedTile';
import CrmTicketUpdateLabel from '../crm-ticket-lifecycle-update/CrmTicketUpdateLabel';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectLifecycleUpdateMessage = ({
  message,
  onTicketLinkClick,
  portalId,
  positionDescriptors,
  senders,
  userId
}) => {
  const objectType = getObjectType(message);
  if (objectType === TICKET) {
    if (isTicketCreatedType(message)) {
      return /*#__PURE__*/_jsx(CrmTicketCreatedTile, {
        message: message,
        onTicketLinkClick: onTicketLinkClick,
        portalId: portalId,
        positionDescriptors: positionDescriptors,
        senders: senders,
        userId: userId
      });
    }
    return /*#__PURE__*/_jsx(CrmTicketUpdateLabel, {
      message: message,
      onTicketLinkClick: onTicketLinkClick,
      portalId: portalId,
      senders: senders,
      userId: userId
    });
  }
  return null;
};
CrmObjectLifecycleUpdateMessage.displayName = 'CrmObjectLifecycleUpdateMessage';
CrmObjectLifecycleUpdateMessage.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  onTicketLinkClick: PropTypes.func,
  portalId: PropTypes.number.isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmObjectLifecycleUpdateMessage;